var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00391 1.99609H0V0.671875H8.00391V1.99609ZM6 6.00391H0V4.66797H6V6.00391ZM3.99609 10H0V8.66406H3.99609V10ZM9.99609 8.39453L11.0625 7.32812L12 8.27734L9.32812 10.9375L6.66797 8.27734L7.60547 7.32812L8.67188 8.39453V3.33203H9.99609V8.39453Z",
    fill: "#686E76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.077677851edf9a4f63da3a21dbc7da11.svg";
export { ForwardRef as ReactComponent };